import React from 'react'
import { Alert, Button } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false, error: null, errorInfo: null }
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        // Log error details
        console.error('ErrorBoundary caught an error:', error, errorInfo)
        this.setState({
            error,
            errorInfo
        })
    }

    handleReload = () => {
        this.setState({ hasError: false, error: null, errorInfo: null })
    }

    render() {
        if (this.state.hasError) {
            return (
                <Alert
                    message="Something went wrong"
                    description={
                        <div>
                            <p>An error occurred while rendering this component.</p>
                            {process.env.NODE_ENV === 'development' && this.state.error && (
                                <details style={{ marginTop: '10px' }}>
                                    <summary>Error Details (Development Only)</summary>
                                    <pre style={{ 
                                        background: '#f5f5f5', 
                                        padding: '10px', 
                                        marginTop: '10px',
                                        fontSize: '12px',
                                        overflow: 'auto'
                                    }}>
                                        {this.state.error.toString()}
                                        {this.state.errorInfo.componentStack}
                                    </pre>
                                </details>
                            )}
                        </div>
                    }
                    type="error"
                    showIcon
                    action={
                        <Button 
                            size="small" 
                            danger 
                            icon={<ReloadOutlined />}
                            onClick={this.handleReload}
                        >
                            Reload
                        </Button>
                    }
                    style={{ margin: '20px' }}
                />
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
